import React, { useState, useEffect } from 'react';
import { getCookie, setCookieConsent, setDataSaleConsent } from '../utils/cookies';
import './CookieConsentBanner.css';

const CookieConsentBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [preferences, setPreferences] = useState({
    essential: true, // Always true, cannot be disabled
    analytics: true,
    marketing: true,
    dataSale: false, // explicit opt-in required for selling anonymised cookie data
  });

  useEffect(() => {
    // Check if user has already made a choice
    const consent = getCookie('cookie_consent');
    const sale = getCookie('cookie_data_sale');
    if (!consent) {
      setShowBanner(true);
    }

    // initialise preference state if cookies exist
    if (consent) {
      const analytics = consent === 'accepted';
      const marketing = consent === 'accepted';
      setPreferences(prev => ({
        ...prev,
        analytics,
        marketing,
        dataSale: sale === 'accepted',
      }));
    }
  }, []);

  const handleAcceptAll = () => {
    setCookieConsent('accepted');
    setDataSaleConsent('accepted');
    setShowBanner(false);
    // Here you could trigger loading of analytics/marketing scripts or initialize advertisers
  };


  const handleManagePreferences = () => {
    setShowPreferences(true);
  };

  const handleSavePreferences = () => {
    const choice = preferences.analytics || preferences.marketing ? 'accepted' : 'essential_only';
    setCookieConsent(choice);
    // data sale is separate opt-in/opt-out
    setDataSaleConsent(preferences.dataSale ? 'accepted' : 'declined');

    setShowBanner(false);
    setShowPreferences(false);
  };

  const handlePreferenceChange = (type, value) => {
    setPreferences(prev => ({
      ...prev,
      [type]: value,
    }));
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-overlay">
        <div className="cookie-consent-content">
        {!showPreferences ? (
          <>
            <div className="cookie-consent-text">
              <h3>We use cookies</h3>
              <p>
                We use cookies to enhance your experience on our website. Essential cookies are necessary for the website to function properly.
                Analytics cookies help us understand how you use our site, and marketing cookies allow us to show you relevant advertisements.
                We may also offer anonymised, aggregated cookie data to third parties; this is only done if you explicitly agree below.
              </p>
              <p>
                By clicking "Accept All", you consent to the use of all cookies. You can manage your preferences or decline non-essential cookies.
              </p>
            </div>
            <div className="cookie-consent-buttons">
              <button className="btn-secondary" onClick={handleManagePreferences}>
                Manage Preferences
              </button>
              <button className="btn-primary" onClick={handleAcceptAll}>
                Accept All
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="cookie-consent-text">
              <h3>Manage Cookie Preferences</h3>
              <div className="cookie-preferences">
                <div className="preference-item">
                  <label>
                    <input
                      type="checkbox"
                      checked={preferences.essential}
                      disabled
                    />
                    <strong>Essential Cookies</strong>
                    <p>These cookies are necessary for the website to function and cannot be disabled.</p>
                  </label>
                </div>
                <div className="preference-item">
                  <label>
                    <input
                      type="checkbox"
                      checked={preferences.analytics}
                      onChange={(e) => handlePreferenceChange('analytics', e.target.checked)}
                    />
                    <strong>Analytics Cookies</strong>
                    <p>These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.</p>
                  </label>
                </div>
                <div className="preference-item">
                  <label>
                    <input
                      type="checkbox"
                      checked={preferences.marketing}
                      onChange={(e) => handlePreferenceChange('marketing', e.target.checked)}
                    />
                    <strong>Marketing Cookies</strong>
                    <p>These cookies are used to track visitors across websites to display relevant advertisements.</p>
                  </label>
                </div>
                <div className="preference-item">
                  <label>
                    <input
                      type="checkbox"
                      checked={preferences.dataSale}
                      onChange={(e) => handlePreferenceChange('dataSale', e.target.checked)}
                    />
                    <strong>Sell Anonymised Cookie Data</strong>
                    <p>If you agree, we may share aggregated and anonymised cookie data with third-party partners. No personally identifiable information is included.</p>
                  </label>
                </div>
              </div>
            </div>
            <div className="cookie-consent-buttons">
              <button className="btn-secondary" onClick={() => setShowPreferences(false)}>
                Back
              </button>
              <button className="btn-primary" onClick={handleSavePreferences}>
                Save Preferences
              </button>
            </div>
          </>
        )}
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;